import React, { useState, useRef, useMemo } from "react";
import { Modal, message, Table, Alert, Tag, Space } from "antd";
import { lib } from "../../index";
import "./dept-add-user-modal.less";
import SearchConditionList from "../../config-center-v3/search-list/search-condition-list";
import Immutable from "immutable";
import { CloseOutlined } from "@ant-design/icons";

const searchList = [
    {
        type: "input",
        label: "用户名",
        key: "userName",
        trimMode: "all",
        colProps: { span: 8 },
    },
    {
        type: "input",
        label: "姓名",
        key: "nickName",
        trimMode: "all",
        colProps: { span: 8 },
    },
    {
        type: "input",
        label: "手机号",
        key: "mobile",
        trimMode: "all",
        colProps: { span: 8 },
    },
];

export default function DeptAddUserModal({ departmentId, onClose, visible }) {
    let [pagination, setPagination] = useState({ pageSize: 10, currentPage: 1, totalCount: 1 });
    let [dataSource, setDataSource] = useState([]);
    let [loading, setLoading] = useState(false);
    let [selectedRows, setSelectedRows] = useState([]);
    let searchRef = useRef();
    const rowKey = "id";
    const title = "添加人员";

    function fetchList(pagination) {
        const params = searchRef.current.getSearchCondition();
        setLoading(true);
        // 使用与account-manage页面一致的接口
        const requestUrl =
            lib.config.webToken == "admin" ? "/ucenter-admin/waiter/page" : "/ucenter-customer/user/sub/page";
        lib.request({
            url: requestUrl,
            data: {
                ...pagination,
                ...params,
                departmentId,
                systemCode: lib.config.systemCode,
            },
            needMask: true,
            success: res => {
                setLoading(false);
                setDataSource(res.dataList);
                setPagination(res.page);
            },
            fail: () => {
                setLoading(false);
            },
        });
    }

    function onSelect(record, selected) {
        select(record, selected);
    }

    function select(record, selected) {
        let recordKeyValue = record[rowKey];
        setSelectedRows(selectedRows => {
            if (selected && selectedRows.every(item => item[rowKey] !== recordKeyValue)) {
                return [...selectedRows, record];
            } else {
                return selectedRows.filter(item => item[rowKey] !== recordKeyValue);
            }
        });
    }

    function onSelectAll(selected, selectedRows, changeRows) {
        changeRows.forEach(item => {
            select(item, selected);
        });
    }

    function okHandle() {
        if (selectedRows.length < 1) {
            message.warn("请选择至少一条数据");
            return;
        }

        lib.request({
            url: "/ucenter-admin/dept/user/batch/bind",
            data: {
                departmentId,
                userIds: selectedRowKeys,
                systemCode: lib.config.systemCode,
            },
            needMask: true,
            success: res => {
                onClose(true);
                message.success("添加成功！");
            },
        });
    }

    function afterClose() {
        setPagination({ pageSize: 10, currentPage: 1, totalCount: 1 });
        setSelectedRows([]);
    }

    function cancelHandle() {
        onClose();
    }

    function handleTableChange(pagination) {
        let page = {
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
            totalCount: pagination.total,
        };
        setPagination(pagination);
        fetchList(page);
    }

    let addBatchColumns = [
        {
            title: "用户名",
            dataIndex: "userName",
            width: 120,
        },
        {
            title: "姓名",
            dataIndex: "nickName",
            width: 100,
        },
        {
            title: "手机号",
            dataIndex: "mobile",
            width: 120,
        },
        {
            title: "工号",
            dataIndex: "empno",
            width: 100,
        },
        {
            title: "创建时间",
            dataIndex: "createdAt",
            width: 150,
        },
    ];

    const handleClose = removedTag => {
        const newTags = selectedRows.filter(tag => tag[rowKey] !== removedTag[rowKey]);
        setSelectedRows(newTags);
    };

    const forMap = tag => {
        return (
            <span
                key={tag[rowKey]}
                style={{
                    display: "inline-block",
                }}>
                <Tag
                    color={"#F6F7FA"}
                    closable
                    onClose={e => {
                        e.preventDefault();
                        handleClose(tag);
                    }}
                    closeIcon={<CloseOutlined style={{ color: "rgba(0, 0, 0, 0.85)" }} />}>
                    <span style={{ color: "rgba(0, 0, 0, 0.85)" }}>{tag.userName}</span>
                </Tag>
            </span>
        );
    };

    const header = useMemo(() => {
        const tagChild = selectedRows.map(forMap);
        return (
            <div>
                <Alert message={`您当前正在为部门【${lib.getParam("deptName")}】添加人员`} type="info" />
                <div className={"selected-tag"}>
                    <div className={"selected-tag-label"}>{title}：</div>
                    <div className={"selected-tag-content"}>
                        <Space wrap>{tagChild}</Space>
                    </div>
                </div>
            </div>
        );
    }, [selectedRows]);

    const selectedRowKeys = useMemo(() => {
        return selectedRows.reduce((prev, curr) => [...prev, curr[rowKey]], []);
    }, [selectedRows]);

    return (
        <Modal
            title={title}
            open={visible}
            maskClosable={false}
            destroyOnClose={true}
            onOk={() => okHandle()}
            onCancel={() => cancelHandle()}
            afterClose={afterClose}
            width={800}
            wrapClassName={"dept-add-user-modal config-center-v3"}>
            {header}
            <div className={"search-list"}>
                {searchList?.length ? (
                    <div className={"search-condition-panel"}>
                        <SearchConditionList
                            ref={searchRef}
                            showMini={false}
                            defaultSearch={Immutable.Map({})}
                            searchKeyList={searchList}
                            onSearch={(search, reset) => {
                                pagination.currentPage = 1;
                                fetchList(pagination);
                            }}
                        />
                    </div>
                ) : (
                    ""
                )}
                <Table
                    loading={loading}
                    dataSource={dataSource}
                    size={"small"}
                    columns={addBatchColumns}
                    scroll={{ x: "max-content", y: 350 }}
                    onChange={handleTableChange}
                    rowSelection={{
                        selectedRowKeys,
                        onSelect: onSelect,
                        onSelectAll: onSelectAll,
                    }}
                    rowKey={rowKey}
                    pagination={{
                        pageSize: pagination.pageSize,
                        current: pagination.currentPage,
                        total: pagination.totalCount,
                    }}
                />
            </div>
        </Modal>
    );
}
